import { render, staticRenderFns } from "./me-aside.vue?vue&type=template&id=d28b7570"
import script from "./me-aside.vue?vue&type=script&lang=js"
export * from "./me-aside.vue?vue&type=script&lang=js"
import style0 from "./me-aside.vue?vue&type=style&index=0&id=d28b7570&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports